if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

      }

      
      onSubmitHandler(evt) {
        evt.preventDefault();

        // BLOQUEIO DE SUBMISSÃO PERSONALIZADO
        const requiredHidden = this.form.querySelectorAll('input[type="hidden"][data-required-hidden]');
        const allValidHidden = [...requiredHidden].every(i => i.value && i.value.trim() !== '');

        // Validar campos customizados (todos tipos)
        const customFields = document.querySelectorAll('[data-custom-field][data-required]');

        let allCustomValid = true;
        let firstInvalidField = null;

        customFields.forEach(field => {
          const parent = field.closest('.product__custom-field');

          let isValid = true;

          // Detectar tipo
          const type = field.type;
          const tag = field.tagName.toLowerCase();

          // 1) COLOR PICKER - não permitir valor vazio ou default
          if (type === "color") {
            if (!field.value || field.value === "#000000") {
              isValid = false;
            }
          }

          // 2) CHECKBOX - precisa estar marcado
          else if (type === "checkbox") {
            if (!field.checked) {
              isValid = false;
            }
          }

          // 3) RADIO - validar todos os radios do mesmo name
          else if (type === "radio") {
            const group = document.querySelectorAll(`.product__custom-fields .custom-field-radio-group input[type="radio"][name="${field.name}"]`);

            const oneChecked = [...group].some(r => r.checked);

            if (!oneChecked) {

              isValid = false;

              // Para focar no primeiro radio do grupo     
              if (!firstInvalidField) {
                firstInvalidField = field;
              }
            }
          }

          // 4) SELECT - precisa ter value válido
          else if (tag === "select") {
            if (!field.value || field.value.trim() === "") {
              isValid = false;
            }
          }

          // 5) Campos normais (text, number, hidden, etc)
          else {
            if (!field.value || field.value.trim() === '') {
              isValid = false;
            }
          }


          // APLICAR ERROS
          if (!isValid) {
            allCustomValid = false;
            if (parent) parent.classList.add('product__custom-field--error');

            if (!firstInvalidField) {
              firstInvalidField = field;
            }
          } else {
            if (parent) parent.classList.remove('product__custom-field--error');
          }
        });


        // Dar foco + scroll no primeiro inválido
        if (firstInvalidField) {
          console.log(firstInvalidField)
          firstInvalidField.focus({ preventScroll: true });
          firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }


        // Validar hidden fields
        if (!allValidHidden || !allCustomValid) {
          this.handleErrorMessage(window.productCustomizationFields.add_to_cart_error_msg);
          return; // Impede envio
        }


        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);

          console.log(this.cart)
          
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
